{
  "qualities": {
    "high": "Høy",
    "medium": "Middels",
    "low": "Lav"
  },
  "legend": {
    "high": "Høy bonitet",
    "medium": "Middels bonitet",
    "low": "Lav bonitet",
    "total": "I alt"
  }
}
